import styles from './AuthenticatedLayout.module.scss';
import Banner from '@components/Banner';
import { getPushes } from '@api/apiClient/news';
import { Outlet } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
// import { AccountResponse } from '@api/Responses/AccountResponse';

const AuthenticatedLayout = ({ region }: { region: string }) => {
  const [isPushesVisible, setIsPushesVisible] = useState<boolean>(false);

  const {
    data: dataGetPushes,
    refetch: refetchGetPushes
  } = useQuery({
    queryFn: () => getPushes(region),
    queryKey: ['pushes'],
    retry: 1
  });

  useEffect(() => {
    if (dataGetPushes && dataGetPushes.items.length) {
      setIsPushesVisible(true);
    }
  }, [dataGetPushes]);

  useEffect(() => {
    setIsPushesVisible(false);
    refetchGetPushes();
  }, [region]);

  return (
    <div className={styles.root}>
      <Outlet />
      {isPushesVisible && (
        <Banner
          bottom={15}
          handlerRefetchGetPushes={refetchGetPushes}
          handlerSetIsPushesVisible={setIsPushesVisible}
          isPositionFixed
          pushes={dataGetPushes!.items}
          right={15}
          withAnimation
        />
      )}
    </div>
  );
};

export default AuthenticatedLayout;
